module.exports = __webpack_public_path__ + "static/CareLabel-v3-no-border-d8873b904442e38eab14303bfc7b16c5.svg";